"use client";

import React, { useState, useEffect } from "react";
import { MapPin, Copy, Check, Clock, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Table, TableBody, TableRow, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const address = "+420 733 465 127";
const hoursData = [{
  day: "Pondělí",
  hours: "09:00 - 20:00"
}, {
  day: "Úterý",
  hours: "09:00 - 20:00"
}, {
  day: "Středa",
  hours: "09:00 - 20:00"
}, {
  day: "Čtvrtek",
  hours: "09:00 - 20:00"
}, {
  day: "Pátek",
  hours: "09:00 - 20:00"
}, {
  day: "Sobota",
  hours: "10:00 - 17:00"
}, {
  day: "Neděle",
  hours: "ZAVŘENO"
}];
export default function VisitUsToday() {
  const [isCopied, setIsCopied] = useState(false);
  const [currentDayIndex, setCurrentDayIndex] = useState<number | null>(null);
  useEffect(() => {
    setCurrentDayIndex(new Date().getDay());
  }, []);
  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy address", err);
    }
  };
  const mapsUrl = `tel:${address.replace(/\s/g, "")}`;
  return <section data-section-id="233415" id="rezervujte-si-svůj-čas" className="w-full py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <Badge variant="outline" className="w-fit text-primary border-primary/30 bg-primary/10">
                <Clock className="size-3.5 mr-1" />
                Diskrétní rezervace
              </Badge>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tight text-foreground">
                Rezervujte si svůj čas
              </h2>
              <p className="text-lg text-muted-foreground font-sans max-w-md">
                Pro zachování maximální diskrétnosti a osobního přístupu přijímáme rezervace výhradně telefonicky.
              </p>
            </div>

            <div className="flex flex-col space-y-6 bg-secondary/50 p-6 md:p-8 rounded-2xl border border-border/40 backdrop-blur-md">
              <div className="flex items-start space-x-4">
                <div className="bg-primary/20 p-3 rounded-full shrink-0 mt-1">
                  <Navigation className="size-6 text-primary" />
                </div>
                <div className="space-y-1">
                  <h3 className="text-xl font-semibold font-default text-foreground">Rezervační linka</h3>
                  <p className="text-primary font-serif text-3xl md:text-4xl leading-relaxed tracking-wider">
                    {address}
                  </p>
                </div>
              </div>

              <div className="pt-4 flex flex-wrap gap-3">
                <Button onClick={handleCopyAddress} variant="default" className="shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8">
                  {isCopied ? <>
                      <Check className="size-4 mr-2" />
                      Zkopírováno
                    </> : <>
                      <Copy className="size-4 mr-2" />
                      Kopírovat číslo
                    </>}
                </Button>
                <Button variant="outline" className="shadow-sm border-primary/40 text-primary hover:bg-primary/10 rounded-full px-8" asChild>
                  <Link to={mapsUrl}>
                    Zavolat nyní
                  </Link>
                </Button>
              </div>
            </div>
            
            {}
            <div className="relative w-full h-48 md:h-64 rounded-2xl overflow-hidden shadow-2xl border border-border/30">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660511/img/sensu_salon_interior.png" alt="Atmosféra našeho salonu" className="w-full h-full object-cover opacity-80" />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent pointer-events-none" />
            </div>
          </div>

          {}
          <div className="relative">
            {}
            <div className="absolute -inset-1 bg-gradient-to-br from-primary/30 to-accent/10 rounded-3xl blur-3xl opacity-40 -z-10" />
            
            <Card className="shadow-4xl border-border/20 bg-card/80 backdrop-blur-xl overflow-hidden rounded-3xl">
              <CardHeader className="pb-4 border-b border-border/20 bg-muted/20">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <CardTitle className="text-2xl font-default flex items-center gap-2 text-foreground">
                      <Clock className="size-5 text-primary" />
                      Otevírací doba
                    </CardTitle>
                    <CardDescription className="font-sans text-base text-muted-foreground">
                      Jsme tu pro vaše potěšení
                    </CardDescription>
                  </div>
                  
                </div>
              </CardHeader>
              <CardContent className="pt-6 px-4 md:px-6">
                <Table>
                  <TableBody>
                    {hoursData.map((item, i) => {
                    const isToday = currentDayIndex === (i + 1) % 7;
                    return <TableRow key={i} data-index={i} className={`
                            border-b-border/10 transition-colors
                            ${isToday ? "bg-primary/5 hover:bg-primary/10 border-l-4 border-l-primary shadow-sm relative z-10" : "hover:bg-muted/20 border-l-4 border-l-transparent"}
                          `}>
                          <TableCell className={`py-4 font-sans text-base ${isToday ? "font-semibold text-primary" : "text-muted-foreground"}`}>
                            {item.day}
                            {isToday && <span className="ml-2 text-xs font-medium text-primary uppercase tracking-widest">
                                (Dnes)
                              </span>}
                          </TableCell>
                          <TableCell className={`py-4 text-right font-sans text-base ${isToday ? "font-semibold text-foreground" : "text-muted-foreground"}`}>
                            {item.hours}
                          </TableCell>
                        </TableRow>;
                  })}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}